import { css } from '@flipster/styled-system/css';

function getYouTubeVideoId(url: string) {
  const regex =
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  const match = url.match(regex);
  return match ? match[1] : null;
}

interface Props {
  title: string | null | undefined;
  url: string | null | undefined;
}

export const EmbeddedYoutube = ({ title, url }: Props) => {
  if (!url) return null;
  const id = getYouTubeVideoId(url);
  if (!id) return null;

  return (
    <div
      className={css({
        position: 'relative',
        pt: '56.25%',
        height: 0,
        overflow: 'hidden',
        maxWidth: '100%',
      })}
    >
      <iframe
        width='800'
        height='450'
        src={`https://www.youtube.com/embed/${id}`}
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
        title={title || 'Embedded YouTube video'}
        allowFullScreen
        className={css({ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' })}
      />
    </div>
  );
};
